var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]},[_c('b-spinner',{attrs:{"variant":"pending","small":_vm.small,"label":"Loading"}}),_vm._v(" "),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }